export { CTA_FORM_NAMES } from 'LiveBoard/components/shared/CallToAction/types/forms/constants'

export const FORM_FIELD_TYPES = {
  text: 'text',
  longText: 'long_text',
  select: 'select',
  email: 'email',
  tel: 'tel',
  hidden: 'hidden'
}

export const HIDDEN_FIELDS_SOURCES = {
  queryParams: 'query_params',
  configuration: 'configuration',
  customField: 'custom_field'
}